export default "__VITE_ASSET__daf8c580__"